import { OutcomeType, QuoteRejectReason, RandomizationResultType, TurndownOutcome } from '@/api/apis/case';
import { CustomerCaseStatus } from '../status/case-status.types';

export enum ActivityEventLogType {
  UnderClinicalScreening = CustomerCaseStatus.UnderClinicalScreening,
  CaseInitiatedForOCS = CustomerCaseStatus.CaseInitiatedForOCS,
  CaseDeclined = CustomerCaseStatus.CaseDeclined,
  LogisticsQuoteReceived = CustomerCaseStatus.LogisticsQuoteReceived,
  LogisticsQuoteApproved = 'LogisticsQuoteApproved',
  LogisticsQuoteRecalled = CustomerCaseStatus.LogisticsQuoteRecalled,
  LogisticsQuoteDeclined = CustomerCaseStatus.LogisticsQuoteDeclined,
  RandomizationResultSet = 'RandomizationResultSet',
  TeamDeploymentInProgress = CustomerCaseStatus.TeamDeploymentInProgress,
  AtDonorHospital = CustomerCaseStatus.AtDonorHospital,
  CaseCanceled = CustomerCaseStatus.CaseCanceled,
  OrganOnOCS = CustomerCaseStatus.OrganOnOCS,
  OrganOnSCS = 'OrganOnSCS',
  OrganInTransit = CustomerCaseStatus.OrganInTransit,
  OrganAtTXCenter = CustomerCaseStatus.OrganAtTXCenter,
  OrganOffOCS = CustomerCaseStatus.OrganOffOCS,
  OrganOffSCS = 'OrganOffSCS',
  TransplantNotCompleted = CustomerCaseStatus.TransplantNotCompleted,
  NOPServiceCompleted = CustomerCaseStatus.NOPServiceCompleted,
  NOPInvoiceReceived = CustomerCaseStatus.NOPInvoiceReceived,
  NOPInvoiceUpdated = 'NOPInvoiceUpdated',
  CaseClosed = CustomerCaseStatus.CaseClosed,
  PendingServiceApproval = CustomerCaseStatus.PendingServiceApproval,
  ServiceApprovedByTxc = 'ServiceApprovedByTxc',
}

export enum InvoiceUpdateStatus {
  Open = 'Open',
  PartiallyCredited = 'PartiallyCredited',
  FullyCredited = 'FullyCredited',
  PartiallyPaid = 'PartiallyPaid',
  Paid = 'Paid',
}

export type InvoiceUpdateStatusDetails = {
  status: InvoiceUpdateStatus;
  invoiceNumber: null | string;
};

export type ActivityDetailsLog = {
  outcomeType: OutcomeType | null;
  quoteRejectReason: QuoteRejectReason | null;
  turndownOutcome: TurndownOutcome | null;
  randomizationResult: RandomizationResultType | null;
  comment: string | null;
  invoiceUpdateStatusDetails?: InvoiceUpdateStatusDetails;
  // Set only on the ServiceApprovedByTxc entry — the TXC user who approved the service.
  reviewerFirstName?: string | null;
  reviewerLastName?: string | null;
};

export type ActivityCaseLog = {
  activityStatus: ActivityEventLogType;
  timestamp: string;
  activityDetails: ActivityDetailsLog;
};

export type CaseActivityLog = {
  caseId: string;
  activityLogs: Array<ActivityCaseLog>;
};
